module.exports = __webpack_public_path__ + "static/cartachicoestasconociendo-2a5c1e1c6322741f0070399d7d71c4d6.jpg";